import { useEffect, useState } from "react";
import { api } from "@/lib/api";

let cache = null;

export function useSettings() {
  const [s, setS] = useState(cache || {});
  useEffect(() => {
    if (cache) return;
    api.get("/settings").then(({ data }) => { cache = data; setS(data); }).catch(() => {});
  }, []);
  return s;
}

export const resetSettingsCache = () => { cache = null; };
